import { render, staticRenderFns } from "./VisaoGeralCardTotalizadorRastreabilidade.vue?vue&type=template&id=3554bf04&scoped=true&lang=pug"
import script from "./VisaoGeralCardTotalizadorRastreabilidade.vue?vue&type=script&lang=js"
export * from "./VisaoGeralCardTotalizadorRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./VisaoGeralCardTotalizadorRastreabilidade.vue?vue&type=style&index=0&id=3554bf04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554bf04",
  null
  
)

export default component.exports